import React from 'react';
import testIds from '@smart-tv/e2e/shared/variables';
import LogoNorlys from '@smart-tv/components/logo-norlys/logo-norlys';
import styles from './image.module.scss';

export interface ImageRootProps {}

interface Props {
  cover: string;
  children?: React.ReactNode | React.ReactNode[];
}

export const ImageRight: React.FC<Props> = (props: Props) => {
  const { children, cover } = props;

  return (
    <div className={styles['image-right']} 
      style={{ backgroundImage: `url(${cover})` }} 
      data-testid={testIds.login.coverImage}
    >
      <LogoNorlys className={styles['logo']} width={150} height={28.8} data-testid={testIds.login.logo} />
      {children}
    </div>
  );
};

export default ImageRight;
